/* @flow */
import * as React from 'react';

import ComposableTableSort from '../ComposableTableSort.jsx';
import ComposableTableHeader from '../ComposableTableHeader.jsx';
import type { ColumnHeader, SortDirection } from '../ComposableTable.jsx';

export function getHeader(header: ColumnHeader) {
  return (
    <th key={header.name}>
      <ComposableTableHeader columnHeader={header} />
    </th>
  );
}

export function getSortableHeader(
  header: ColumnHeader,
  sortColumn: ?string,
  sortDirection: ?SortDirection,
  handleSort: Function
) {
  return (
    <ComposableTableSort
      key={header.name}
      columnHeader={header}
      sortColumn={sortColumn}
      sortDirection={sortDirection}
      onClick={handleSort}>
      <ComposableTableHeader columnHeader={header} />
    </ComposableTableSort>
  );
}
